<template>
  <div>
    <div ref="peerRef"></div>
    <div class="loading-bg" v-if="loading">
      <div class="loading">
        <h2>{{ loadingText }}</h2>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useOverViewStore } from '@/store';
import { storeToRefs } from 'pinia';
const store = useOverViewStore();
const { ueStatus } = storeToRefs(store);

const loading = ref(true);
let loadingText = ref('三维场景加载中');
const props = defineProps({
  videoId: {
    type: String,
    default: '',
  },
});

const peerRef = ref(null);
// 加载peer-stream
const loadPeerStream = () => {
  const ps = document.createElement('video', { is: 'peer-stream' });
  ps.style.width = '100%';
  ps.style.height = '100%';
  ps.style.backgroundRepeat = 'no-repeat';
  ps.style.backgroundSize = 'cover';
  ps.style.backgroundPosition = 'center';
  ps.id = props.videoId; // peer-stream地址
  peerRef.value.appendChild(ps);

  window.ps.addEventListener('playing', (e) => {
    console.log('peer-stream is playing');
    loadingText.value = '三维场景加载完成';
    loading.value = false;
    ueStatus.value = true;
  });
  window.ps.addEventListener('suspend', (e) => {
    console.log('三维场景停止渲染');
    loading.value = true;
    loadingText.value = '三维场景停止渲染';
    ueStatus.value = false;
  });
  window.ps.addEventListener('resize', (e) => {
    console.log('video元素被拉伸');
  });
  window.ps.addEventListener('pointerlockchange', (e) => {
    console.log('沉浸式鼠标切换');
  });
  window.ps.addEventListener('playerqueue', (e) => {
    console.log('返回用户排队情况，seq表示当前排队序号', e);
    loading.value = true;
    loadingText.value = '等待连接三维场景,目前排队序号为：' + e.detail.seq;
  });
  window.ps.addEventListener('playerdisconnected', (e) => {
    console.log('signal不在线的回调事件');
    loading.value = true;
    loadingText.value = '三维场景服务掉线';
  });
};

onMounted(() => {
  loadPeerStream();
});

onUnmounted(() => {
  peerRef.value = null;
});
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
